// import React, { useEffect, useState } from "react";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";

// const Checkout = () => {
//   const [cartItems, setCartItems] = useState([]);
//   const [subtotal, setSubtotal] = useState(0);
//   const shippingCost = 50;
//   const vatRate = 0.07;
// const [address, setAddress] = useState({
//   fullName: "",
//   company: "",
//   address: "",
//   locality: "",
//   city: "",
//   state: "",
//   country: "",
//   pincode: "",
//   phone: ""
// });


//   // const address = {
//   //   address: "123 Main Street",
//   //   city: "Surat",
//   //   state: "Gujarat",
//   //   country: "India",
//   //   pincode: "395007",
//   // };

//   useEffect(() => {
//     const savedCart = JSON.parse(localStorage.getItem("cart")) || [];
//     setCartItems(savedCart);

//      const savedAddress = JSON.parse(localStorage.getItem("shippingAddress"));
//   if (savedAddress) setAddress(savedAddress);


//     const calculatedSubtotal = savedCart.reduce(
//       (total, item) => total + item.price * item.quantity,
//       0
//     );
//     setSubtotal(calculatedSubtotal);
//   }, []);

//   const vat = Math.round(subtotal * vatRate);
//   const total = subtotal + vat + shippingCost;
//   const isMobile = window.innerWidth <= 768;

//  const generateInvoice = (e) => {

//     e.preventDefault();

//     const doc = new jsPDF();
//   const now = new Date();
//   const orderNumber = Date.now();
//   const invoiceNumber = "INV" + Math.floor(Math.random() * 1000000);

//   doc.setFontSize(10);
//   doc.text("BILL TO:", 14, 20);
//   doc.setFont("helvetica", "bold");
// doc.text(String(address.fullName || ""), 14, 25);
// doc.text(String(address.company || ""), 14, 30);
// doc.text(String(address.address || ""), 14, 35);
// doc.text(`${String(address.city || "")}, ${String(address.state || "")}, ${String(address.pincode || "")}`, 14, 40);
// doc.text("Place of Supply : 24 Gujarat", 14, 45);

//   doc.setFont("helvetica", "bold");
//   doc.text("Tax Invoice", 160, 20);
//   doc.setFont("helvetica", "normal");
//   doc.text("Original For Recipient", 160, 25);

//   doc.setFontSize(9);
//   doc.text("Order Number", 14, 50);
//   doc.text(String(orderNumber), 45, 50);
//   doc.text("Order Date", 14, 55);
//   doc.text(now.toLocaleString(), 45, 55);

//   doc.text("Invoice Number", 120, 50);
//   doc.text(String(invoiceNumber), 160, 50);
//   doc.text("Invoice Date", 120, 55);
//   doc.text(now.toLocaleString(), 160, 55);

//   doc.setFont("helvetica", "bold");
//   doc.text("SHIP TO:", 14, 65);
//   doc.setFont("helvetica", "normal");
//   doc.text(String(address.name || ""), 14, 70);
//   doc.text(String(address.address || ""), 14, 75);
//   doc.text(
//     `${String(address.city || "")}, ${String(address.state || "")}, ${String(address.pincode || "")}`,
//     14,
//     80
//   );

//     const tableBody = cartItems.map((item, index) => {
//       const gross = item.price * item.quantity;
//       const discount = 0;
//       const taxable = gross - discount;
//       const sgst = +(taxable * 0.09).toFixed(2);
//       const cgst = +(taxable * 0.09).toFixed(2);
//       const totalAmt = taxable + sgst + cgst;

//       return [
//         index + 1,
//         item.pName,
//         "330499",
//         item.quantity,
//         `Rs.${gross.toFixed(2)}`,
//         `Rs.${discount.toFixed(2)}`,
//         `Rs.${taxable.toFixed(2)}`,
//         `SGST @9%: Rs.${sgst}\nCGST @9%: Rs.${cgst}`,
//         `Rs.${totalAmt.toFixed(2)}`
//       ];
//     });
                                                                    
//     // Add other charges (shipping)
//     const shippingTax = +(shippingCost * 0.18).toFixed(2);
//     const shippingRow = [
//       cartItems.length + 1,
//       "Other Charges (Shipping)",
//       "N/A",
//       "-",
//       `Rs.${shippingCost}`,
//       "Rs.0",
//       `Rs.${shippingCost}`,
//       `SGST @9%: Rs.${(shippingCost * 0.09).toFixed(2)}\nCGST @9%: Rs.${(shippingCost * 0.09).toFixed(2)}`,
//       `Rs.${(shippingCost + shippingTax).toFixed(2)}`
//     ];
//     tableBody.push(shippingRow);

//     autoTable(doc, {
//       startY: 90,
//       head: [[
//         "SN",
//         "Description",
//         "HSN",
//         "Qty",
//         "Gross Amount",
//         "Discount",
//         "Taxable Value",
//         "Taxes",
//         "Total"
//       ]],
//       body: tableBody,
//       styles: { fontSize: 8 },
//     });
// const finalY = doc.lastAutoTable.finalY + 10;

// doc.setFont("helvetica", "bold");
// doc.setFontSize(14);
// doc.text("Total:", 14, finalY);

// // Recommended to avoid ₹ issues
// doc.text(`Rs. ${total}`, 50, finalY);


//     doc.setFont("helvetica", "normal");
//     doc.setFontSize(8);
//     doc.text("Terms & Conditions:", 14, finalY + 10);
//     doc.text(
//       "• This invoice is computer generated and does not require a signature.\n" +
//       "• Other charges may include shipping or logistics fees.\n" +
//       "• Includes applicable taxes as per GST norms.",
//       14,
//       finalY + 15
//     );

//     doc.save("invoice.pdf");
//   };


//   return (
//     <div
//       style={{
//         minHeight: "100vh",
      
//         padding: isMobile ? "16px" : "24px 40px",
//         fontFamily: "Segoe UI, sans-serif",
//       }}
//     >
//       <div
//         style={{
//           maxWidth: "100%",
//           margin: "0 auto",
//           display: "grid",
//           gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
//           gap: "32px",
//           backgroundColor: "#ffffff",
//           borderRadius: "16px",
//           padding: isMobile ? "16px" : "24px",
//         }}
//       >
//         {/* Left Section */}
//         <div>
//           <h2 style={{ fontSize: "20px", fontWeight: "600", marginBottom: "16px" }}>
//             Summary Order
//           </h2>
//           <p style={{ fontSize: "14px", color: "#6b7280", marginBottom: "16px" }}>
//             Check your item and select your shipping for a better experience.
//           </p>

//           <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
//             {cartItems.map((item, index) => (
//               <div
//                 key={index}
//                 style={{
//                   display: "flex",
//                   flexDirection: isMobile ? "column" : "row",
//                   gap: "16px",
//                   border: "1px solid #e5e7eb",
//                   padding: "12px",
//                   borderRadius: "8px",
//                   alignItems: isMobile ? "flex-start" : "center",
//                 }}
//               >
//                 <img
//                   src={`https://api.easywayshop.shop/uploads/${item.pImg[0]}`}
//                   alt={item.pName}
//                   style={{
//                     width: isMobile ? "100%" : "112px",
//                     height: isMobile ? "auto" : "120px",
//                     objectFit: "cover",
//                     borderRadius: "8px",
//                   }}
//                 />
//                 <div style={{ flex: 1 }}>
//                   <h4 style={{ fontSize: "14px", fontWeight: "600", margin: 0 }}>
//                     {item.pName}
//                   </h4>
//                   <p style={{ fontSize: "12px", color: "#6b7280", margin: "4px 0" }}>
//                     Size: {item.selectedSize || "-"} | Qty: {item.quantity}
//                   </p>
//                   <p style={{ fontSize: "14px", fontWeight: "500", color: "#1f2937" }}>
//                     ₹{item.price * item.quantity}
//                   </p>
//                 </div>
//               </div>
//             ))}
//           </div>

   
//         </div>

//         {/* Right Section */}
//         <div>
//           <h2 style={{ fontSize: "20px", fontWeight: "600", marginBottom: "16px" }}>
//             Payment Details
//           </h2>
//           <form  style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
//             <div>
//               <label style={{ fontSize: "14px", fontWeight: "500" }}>
//                 Billing Address
//               </label>
//              <div
//   style={{
//     fontSize: "14px",
//     color: "#374151",
//     border: "1px solid #e5e7eb",
//     padding: "12px",
//     borderRadius: "8px",
//     marginTop: "6px",
//   }}
// >
//   <p style={{ margin: 0, fontWeight: 600 }}>{address.fullName || "Name not set"}</p>
//   {address.company && <p style={{ margin: 0 }}>{address.company}
//   {address.address && address.address}</p>}
//   {address.locality && <p style={{ margin: 0 }}>{address.locality}</p>}
//   <p style={{ margin: 0 }}>
//     {address.city}, {address.state} - {address.pincode}
//   </p>
//   <p style={{ margin: 0 }}>
//     {address.country} | 📞 {address.phone}
//   </p>
// </div>

//             </div>
//        <h3 style={{ marginTop: "24px", fontSize: "14px", fontWeight: "500" }}>
//             Available Shipping Method
//           </h3>
//           <label
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               border: "1px solid #e5e7eb",
//               padding: "12px",
//               borderRadius: "8px",
//               cursor: "pointer",
//               marginTop: "12px",
//               marginBottom: "10px",
//               flexDirection: isMobile ? "column" : "row",
//               gap: isMobile ? "10px" : "0",
//               textAlign: isMobile ? "left" : "inherit",
//             }}
//           >
//             <div>
//               <p style={{ fontSize: "14px", fontWeight: "600", margin: 0 }}>
//                 FedEx Delivery
//               </p>
//               <p style={{ fontSize: "12px", color: "#6b7280" }}>
//                 Delivery: 2-3 working days
//               </p>
//             </div>
//             <div style={{ display: "flex", alignItems: "center" }}>
//               <span style={{ fontSize: "14px", fontWeight: "600", color: "green" }}>
//                 ₹{shippingCost}
//               </span>
//               <input type="radio" name="shipping" defaultChecked style={{ marginLeft: "12px" }} />
//             </div>
//           </label>
//             <div
//               style={{
//                 borderTop: "1px solid #e5e7eb",
//                 paddingTop: "16px",
//                 fontSize: "14px",
//               }}
//             >
//               <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px" }}>
//                 <span>Subtotal</span>
//                 <span>₹{subtotal}</span>
//               </div>

//               <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px" }}>
//                 <span>Shipping</span>
//                 <span>₹{shippingCost}</span>
//               </div>
//               <div style={{ display: "flex", justifyContent: "space-between", fontWeight: "600", fontSize: "16px" }}>
//                 <span>Total</span>
//                 <span>₹{total}</span>
//               </div>
//             </div>

       

//       <button
//         onClick={generateInvoice}
//         style={{
//           padding: "12px 24px",
//           background: "black",
//           color: "white",
//           border: "none",
//           borderRadius: "6px",
//           fontWeight: "600",
//           cursor: "pointer",
//         }}
//       >
//         Pay ₹{total} & Download Invoice
//       </button>

//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Checkout;



import React, { useEffect, useState } from "react";
import jsPDF from "jspdf";
import axios from "axios";

import autoTable from "jspdf-autotable";

const Checkout = () => {
  const [cartItems, setCartItems] = useState([]);
  const [subtotal, setSubtotal] = useState(0);
  const shippingCost = 50;
  const vatRate = 0.07;
  const [address, setAddress] = useState({
    fullName: "",
    company: "",
    address: "",
    locality: "",
    city: "",
    state: "",
    country: "",
    pincode: "",
    phone: ""
  });


  // const address = {
  //   address: "123 Main Street",
  //   city: "Surat",
  //   state: "Gujarat",
  //   country: "India",
  //   pincode: "395007",
  // };

  useEffect(() => {
    const savedCart = JSON.parse(localStorage.getItem("cart")) || [];
    setCartItems(savedCart);

    const savedAddress = JSON.parse(localStorage.getItem("shippingAddress"));
    if (savedAddress) setAddress(savedAddress);


    const calculatedSubtotal = savedCart.reduce(
      (total, item) => total + item.price * item.quantity,
      0
    );
    setSubtotal(calculatedSubtotal);
  }, []);

  const vat = Math.round(subtotal * vatRate);
  const total = subtotal + vat + shippingCost;
  const isMobile = window.innerWidth <= 768;


  
  const generateInvoice = (e) => {

     if (e?.preventDefault) e.preventDefault();

    const doc = new jsPDF();
    const now = new Date();
    const orderNumber = Date.now();
    const invoiceNumber = "INV" + Math.floor(Math.random() * 1000000);

    doc.setFontSize(10);
    doc.text("BILL TO:", 14, 20);
    doc.setFont("helvetica", "bold");
    doc.text(String(address.fullName || ""), 14, 25);
    doc.text(String(address.company || ""), 14, 30);
    doc.text(String(address.address || ""), 14, 35);
    doc.text(`${String(address.city || "")}, ${String(address.state || "")}, ${String(address.pincode || "")}`, 14, 40);
    doc.text("Place of Supply : 24 Gujarat", 14, 45);

    doc.setFont("helvetica", "bold");
    doc.text("Tax Invoice", 160, 20);
    doc.setFont("helvetica", "normal");
    doc.text("Original For Recipient", 160, 25);

    doc.setFontSize(9);
    doc.text("Order Number", 14, 50);
    doc.text(String(orderNumber), 45, 50);
    doc.text("Order Date", 14, 55);
    doc.text(now.toLocaleString(), 45, 55);

    doc.text("Invoice Number", 120, 50);
    doc.text(String(invoiceNumber), 160, 50);
    doc.text("Invoice Date", 120, 55);
    doc.text(now.toLocaleString(), 160, 55);

    doc.setFont("helvetica", "bold");
    doc.text("SHIP TO:", 14, 65);
    doc.setFont("helvetica", "normal");
    doc.text(String(address.name || ""), 14, 70);
    doc.text(String(address.address || ""), 14, 75);
    doc.text(
      `${String(address.city || "")}, ${String(address.state || "")}, ${String(address.pincode || "")}`,
      14,
      80
    );

    const tableBody = cartItems.map((item, index) => {
      const gross = item.price * item.quantity;
      const discount = 0;
      const taxable = gross - discount;
      const sgst = +(taxable * 0.09).toFixed(2);
      const cgst = +(taxable * 0.09).toFixed(2);
      const totalAmt = taxable + sgst + cgst;

      return [
        index + 1,
        item.pName,
        "330499",
        item.quantity,
        `Rs.${gross.toFixed(2)}`,
        `Rs.${discount.toFixed(2)}`,
        `Rs.${taxable.toFixed(2)}`,
        `SGST @9%: Rs.${sgst}\nCGST @9%: Rs.${cgst}`,
        `Rs.${totalAmt.toFixed(2)}`
      ];
    });

    // Add other charges (shipping)
    const shippingTax = +(shippingCost * 0.18).toFixed(2);
    const shippingRow = [
      cartItems.length + 1,
      "Other Charges (Shipping)",
      "N/A",
      "-",
      `Rs.${shippingCost}`,
      "Rs.0",
      `Rs.${shippingCost}`,
      `SGST @9%: Rs.${(shippingCost * 0.09).toFixed(2)}\nCGST @9%: Rs.${(shippingCost * 0.09).toFixed(2)}`,
      `Rs.${(shippingCost + shippingTax).toFixed(2)}`
    ];
    tableBody.push(shippingRow);

    autoTable(doc, {
      startY: 90,
      head: [[
        "SN",
        "Description",
        "HSN",
        "Qty",
        "Gross Amount",
        "Discount",
        "Taxable Value",
        "Taxes",
        "Total"
      ]],
      body: tableBody,
      styles: { fontSize: 8 },
    });
    const finalY = doc.lastAutoTable.finalY + 10;

    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("Total:", 14, finalY);

    // Recommended to avoid ₹ issues
    doc.text(`Rs. ${total}`, 50, finalY);


    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.text("Terms & Conditions:", 14, finalY + 10);
    doc.text(
      "• This invoice is computer generated and does not require a signature.\n" +
      "• Other charges may include shipping or logistics fees.\n" +
      "• Includes applicable taxes as per GST norms.",
      14,
      finalY + 15
    );

    doc.save("invoice.pdf");
  };

  const placeOrder = async (e) => {
if (e?.preventDefault) e.preventDefault();

    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const userId = user?.email || "GUEST_USER";

      for (const item of cartItems) {
        const formData = new FormData();

        const timestamp = Date.now();
        const randomNum = Math.floor(100000 + Math.random() * 900000);
        const orderId = `ORDER-${timestamp}-${randomNum}`;
        const orderDate = new Date().toISOString();

        const imageName = item.pImg?.[0]?.split("/").pop() || "";

        console.log("Image being sent:", imageName); // 🔍 DEBUG

        // 🧠 Check if imageName is empty
        if (!imageName) {
          alert(`Image is missing for product: ${item.pName}`);
          continue; // Skip this item
        }

        formData.append("userId", userId);
        formData.append("userName", address.fullName || "Guest");
        formData.append("pName", item.pName);
        formData.append("price", item.price);
        formData.append("qty", item.quantity);
        formData.append("img", imageName);
        formData.append("id", orderId);
        formData.append("orderDate", orderDate);

        await axios.post("https://api.easywayshop.shop/api/v1/addorder", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }


      alert("Order placed successfully!");
      localStorage.removeItem("cart");
      setCartItems([]);

    } catch (error) {
      console.error("Order API error:", error);
      alert("Failed to place order.");
    }
  };

const handleClick = async () => {
  try {
    await generateInvoice();  // First: Generate invoice
    await placeOrder();       // Then: Place order
  } catch (err) {
    console.error("Error during payment process:", err);
  }
};


  return (
    <div
      style={{
        minHeight: "100vh",

        padding: isMobile ? "16px" : "24px 40px",
        fontFamily: "Segoe UI, sans-serif",
      }}
    >
      <div
        style={{
          maxWidth: "100%",
          margin: "0 auto",
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
          gap: "32px",
          backgroundColor: "#ffffff",
          borderRadius: "16px",
          padding: isMobile ? "16px" : "24px",
        }}
      >
        {/* Left Section */}
        <div>
          <h2 style={{ fontSize: "20px", fontWeight: "600", marginBottom: "16px" }}>
            Summary Order
          </h2>
          <p style={{ fontSize: "14px", color: "#6b7280", marginBottom: "16px" }}>
            Check your item and select your shipping for a better experience.
          </p>

          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            {cartItems.map((item, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  gap: "16px",
                  border: "1px solid #e5e7eb",
                  padding: "12px",
                  borderRadius: "8px",
                  alignItems: isMobile ? "flex-start" : "center",
                }}
              >
                <img
                  src={`https://api.easywayshop.shop/uploads/${item.pImg[0]}`}
                  alt={item.pName}
                  style={{
                    width: isMobile ? "100%" : "112px",
                    height: isMobile ? "auto" : "120px",
                    objectFit: "cover",
                    borderRadius: "8px",
                  }}
                />
                <div style={{ flex: 1 }}>
                  <h4 style={{ fontSize: "14px", fontWeight: "600", margin: 0 }}>
                    {item.pName}
                  </h4>
                  <p style={{ fontSize: "12px", color: "#6b7280", margin: "4px 0" }}>
                    Size: {item.selectedSize || "-"} | Qty: {item.quantity}
                  </p>
                  <p style={{ fontSize: "14px", fontWeight: "500", color: "#1f2937" }}>
                    ₹{item.price * item.quantity}
                  </p>
                </div>
              </div>
            ))}
          </div>


        </div>

        {/* Right Section */}
        <div>
          <h2 style={{ fontSize: "20px", fontWeight: "600", marginBottom: "16px" }}>
            Payment Details
          </h2>
          <form style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            <div>
              <label style={{ fontSize: "14px", fontWeight: "500" }}>
                Billing Address
              </label>
              <div
                style={{
                  fontSize: "14px",
                  color: "#374151",
                  border: "1px solid #e5e7eb",
                  padding: "12px",
                  borderRadius: "8px",
                  marginTop: "6px",
                }}
              >
                <p style={{ margin: 0, fontWeight: 600 }}>{address.fullName || "Name not set"}</p>
                {address.company && <p style={{ margin: 0 }}>{address.company}
                  {address.address && address.address}</p>}
                {address.locality && <p style={{ margin: 0 }}>{address.locality}</p>}
                <p style={{ margin: 0 }}>
                  {address.city}, {address.state} - {address.pincode}
                </p>
                <p style={{ margin: 0 }}>
                  {address.country} | 📞 {address.phone}
                </p>
              </div>

            </div>
            <h3 style={{ marginTop: "24px", fontSize: "14px", fontWeight: "500" }}>
              Available Shipping Method
            </h3>
            <label
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                border: "1px solid #e5e7eb",
                padding: "12px",
                borderRadius: "8px",
                cursor: "pointer",
                marginTop: "12px",
                marginBottom: "10px",
                flexDirection: isMobile ? "column" : "row",
                gap: isMobile ? "10px" : "0",
                textAlign: isMobile ? "left" : "inherit",
              }}
            >
              <div>
                <p style={{ fontSize: "14px", fontWeight: "600", margin: 0 }}>
                  FedEx Delivery
                </p>
                <p style={{ fontSize: "12px", color: "#6b7280" }}>
                  Delivery: 2-3 working days
                </p>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <span style={{ fontSize: "14px", fontWeight: "600", color: "green" }}>
                  ₹{shippingCost}
                </span>
                <input type="radio" name="shipping" defaultChecked style={{ marginLeft: "12px" }} />
              </div>
            </label>
            <div
              style={{
                borderTop: "1px solid #e5e7eb",
                paddingTop: "16px",
                fontSize: "14px",
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px" }}>
                <span>Subtotal</span>
                <span>₹{subtotal}</span>
              </div>

              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px" }}>
                <span>Shipping</span>
                <span>₹{shippingCost}</span>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", fontWeight: "600", fontSize: "16px" }}>
                <span>Total</span>
                <span>₹{total}</span>
              </div>
            </div>

            <button
              type="button"
               onClick={handleClick}
              style={{
                padding: "12px 24px",
                background: "black",
                color: "white",
                border: "none",
                borderRadius: "6px",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              Pay ₹{total}
            </button>

          </form>
        </div>
      </div>
    </div>
  );
};

export default Checkout;
